import CustomerSettings from "../../common/settings/userSettings/CustomerSettings";
import React, {useEffect, useState} from "react";
import AssessmentService from "../../../API/customer/AssessmentService";
import {Box} from "@mui/system";
import {Divider, Typography} from "@mui/material";
import {Rating} from "@mui/lab";
import StarIcon from "@mui/icons-material/Star";

const InformationAboutPerformer = ({name, handleModalAlert}) => {
    const [ratingData, setRatingData] = useState([])

    useEffect(() => {
        AssessmentService.getAll(name).then(function (response) {
            setRatingData(response.data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    return <Box sx={{display: "flex", gap: "50px"}}>
        <Box> <CustomerSettings
            handleModalAlert={handleModalAlert}
            settings={false}
            name={name}>
        </CustomerSettings>
        </Box>
        <Box sx={{display: "flex", flexDirection: "column", width: 700, gap: "20px"}}>
            {ratingData.map(el => {
                return <Box sx={{display: "flex", flexDirection: "column", gap: el?.comment ? "15px" : "7px"}}>
                    <Box> {el.organizationAssessments.map((item) => (
                        <Box id={item.organizationRatingIndicator.id} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: "7px 0"
                        }}>
                            <Typography
                                sx={{width: 450}}
                                component="legend">{item.organizationRatingIndicator.name}</Typography>
                            <Rating
                                value={item.rate}
                                precision={1}
                                max={10}
                                emptyIcon={<StarIcon style={{opacity: 0.55}} fontSize="inherit"/>}
                                disabled={true}
                            />
                        </Box>
                    ))}
                    </Box>
                    {el?.comment && <>
                        <Typography sx={{fontStyle: "italic"}}>
                            <span style={{fontWeight: "bold", fontStyle: "normal"}}>Комментарий:</span> {el?.comment}
                        </Typography></>}
                    <Divider/>
                </Box>
            })}
        </Box>
    </Box>
}
export default InformationAboutPerformer